export function initNavbarSecondaryClose() {
    const details = document.querySelector('.js-navbarSecondary');
    if (!details) return;

    const summary = document.querySelector('.js-navbarSecondarySummary');
    const icon = details.querySelector('.navbar__secondary-icon');

    const setA11yState = () => {
        const open = details.hasAttribute('open');

        if (summary) {
            summary.setAttribute(
                'aria-label',
                open ? 'Sluit menu' : 'Open menu'
            );
        }

        if (icon) {
            icon.classList.toggle('fa-bars', !open);
            icon.classList.toggle('fa-times', open);
        }
    };

    const closeMenu = () => {
        details.removeAttribute('open');
        setA11yState();
    };

    const onDocClick = e => {
        if (!details.hasAttribute('open')) return;

        const target = e.target;
        if (!(target instanceof Node)) return;

        if (!details.contains(target)) closeMenu();
    };

    const onDocKeydown = e => {
        if (e.key === 'Escape' && details.hasAttribute('open')) closeMenu();
    };

    const onDetailsClick = e => {
        const el = e.target;

        if (el && el.closest && el.closest('.navbar__secondary-link')) {
            closeMenu();
        }
    };

    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onDocKeydown);
    details.addEventListener('click', onDetailsClick);
    details.addEventListener('toggle', setA11yState);

    setA11yState();
}
